import { render, staticRenderFns } from "./AdminOrganisationDetailView.vue?vue&type=template&id=7add3a72"
import script from "./AdminOrganisationDetailView.vue?vue&type=script&lang=js"
export * from "./AdminOrganisationDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports